module.exports = __webpack_public_path__ + "static/img/pic2.3b84d51.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/recordInformation/pic2.png
// module id = 1687
// module chunks = 2